import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, ScrollToPlugin);
let mm = gsap.matchMedia();

// Overlapping 50-50 panels
const panels = gsap.utils.toArray(".panel");
console.log(panels);

gsap.set(panels, {
  zIndex: (i) => i + 1
});

panels.forEach((panel, i) => {
  if (i === panels.length) return;
  const next = panels[i + 1] as Element;

  ScrollTrigger.create({
    trigger: panel as Element,
    start: "top top",
    endTrigger: next,
    end: "bottom top",
    pin: true,
    pinSpacing: false,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    scrub: 1,
  })
});

// Logos
ScrollTrigger.create({
  trigger: ".logos",
  start: "top top",
  end: "bottom top",
  pin: true,
  pinSpacing: false,
  anticipatePin: 1,
  invalidateOnRefresh: true,
  scrub: 1,
});

// Scrolling stats - only on devices 768px and above
// mm.add("(min-width: 768px)", () => {
//   const section = document.querySelector(".scrolling-stats") as HTMLElement | null;
//   if (!section) return;

//   const textWrapper = section.querySelector(".scrolling-stats-content-text-wrapper") as HTMLElement | null;
//   const statsWrapper = section.querySelector(".scrolling-stats-content-stats-wrapper") as HTMLElement | null;
  
//   if (!textWrapper || !statsWrapper) return;

//   ScrollTrigger.create({
//     trigger: section,
//     start: "top top",
//     end: "bottom 75%",
//     pin: ".scrolling-stats-content",
//     pinSpacing: false,
//     anticipatePin: 1,
//     invalidateOnRefresh: true,
//     scrub: 1,
//     onUpdate: (self) => {
//       const progress = self.progress;
      
//       gsap.set(textWrapper, {
//         y: 0
//       });
      
//       const moveDistance = -750;
//       gsap.set(statsWrapper, {
//         y: progress * moveDistance
//       });
//     }
//   });
// });
mm.add("(min-width: 768px)", () => {
  const section       = document.querySelector(".scrolling-stats") as HTMLElement | null;
  if (!section) return;

  const textWrapper   = section.querySelector(".scrolling-stats-content-text-wrapper") as HTMLElement | null;
  const statsMask     = section.querySelector(".scrolling-stats-content-stats-wrapper") as HTMLElement | null; // viewport/mask
  const statsScroller = section.querySelector(".scrolling-stats-content-stats") as HTMLElement | null;         // moves
  if (!textWrapper || !statsMask || !statsScroller) return;

  const movementFactor = 5;
  const extraPixels    = 200;
  const buffer         = 500;

  textWrapper.style.position = "static";
  textWrapper.style.top = "auto";
  statsMask.style.overflow = "hidden";

  const getNaturalMove = () => Math.max(0, statsScroller.scrollHeight - statsMask.clientHeight);

  const getBoostedMove = () => Math.max(0, getNaturalMove() * movementFactor + extraPixels);

  const st = ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: () => "+=" + (getBoostedMove() + buffer),
    pin: textWrapper,
    pinSpacing: false,
    scrub: 1,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    onRefresh: () => {
      gsap.set(statsScroller, { y: 0 });
    },
    onUpdate: (self) => {
      gsap.set(statsScroller, { y: -getBoostedMove() * self.progress });
    }
  });

  const refresh = () => st.refresh();
  window.addEventListener("resize", refresh);
  statsScroller.querySelectorAll("img").forEach(img => {
    if (!img.complete) img.addEventListener("load", refresh, { once: true });
  });
  statsScroller.querySelectorAll("video").forEach(v => {
    if (v.readyState < 1) v.addEventListener("loadedmetadata", refresh, { once: true });
  });

  return () => {
    window.removeEventListener("resize", refresh);
    section.style.removeProperty("padding-bottom");
    st.kill();
  };
});


// // Initialize GSAP animations when DOM is loaded
// window.addEventListener("DOMContentLoaded", () => {

// });

// // Scroll-triggered animations
window.addEventListener("load", () => {
  ScrollTrigger.refresh();
  // initAccordionAnimations();
});

// Export for potential use in other modules
export const sohtGSAP = {
  init: () => {
    console.log("SOHT GSAP animations initialized");
    // initAccordionAnimations();
  },
  refresh: () => {
    ScrollTrigger.refresh();
  }
};
